import { Column, Entity, JoinColumn, OneToMany, OneToOne, PrimaryGeneratedColumn } from 'typeorm';
import { PlageHoraire } from './plage-horaire.entity';
import { TableauPlageHoraire } from './tableau-plage-horaire.entity';

@Entity('horaire')
export class Horaire {
    static key = 'horaire';

    @PrimaryGeneratedColumn()
    id: number;

    @Column({ nullable: true })
    fk_id_tableau_plage_horaire: number;

    @OneToOne(() => TableauPlageHoraire, { cascade: true })
    @JoinColumn({ name: 'fk_id_tableau_plage_horaire', referencedColumnName: 'id' })
    tableauPlageHoraire: TableauPlageHoraire;

    @OneToMany(() => PlageHoraire, (plageHoraire: PlageHoraire) => plageHoraire.horaire, { cascade: true })
    plagesHoraires: PlageHoraire[];
}
